module.exports = __webpack_public_path__ + "static/img/egg_g_02.4338f33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/g/egg_g_02.png
// module id = kjh3
// module chunks = 1